<template>
  <v-row class="placeholder">
    <v-progress-circular indeterminate></v-progress-circular>
  </v-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.placeholder {
  background: #f4f4f4;
  height: 100%;
  margin: 0;
  color: #bbb;
  justify-content: center;
  align-items: center;
}
</style>
